import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-myApp-shelf",
  "use": "icon-myApp-shelf-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-myApp-shelf\"><path d=\"M608 192c17.67 0 32 14.33 32 32s-14.33 32-32 32H416c-17.67 0-32-14.33-32-32s14.33-32 32-32h192z m288-64H128v192h768V128zM772.55 576c7.26 0.62 14.35 3.7 19.9 9.26l135.76 135.76c12.5 12.5 12.5 32.76 0 45.25-12.5 12.5-32.76 12.5-45.26 0l-83.01-83.01L800 928c0 17.67-14.33 32-32 32s-32-14.33-32-32l-0.06-241.09-79.26 79.36c-12.5 12.5-32.76 12.5-45.25 0-12.5-12.5-12.5-32.76 0-45.25l135.76-135.76a31.898 31.898 0 0 1 19.9-9.26h5.46zM928 64c17.67 0 32 14.33 32 32v256c0 17.67-14.33 32-32 32h-32v96c0 17.67-14.33 32-32 32s-32-14.33-32-32v-96H192v512h352c17.67 0 32 14.33 32 32s-14.33 32-32 32H160c-17.67 0-32-14.33-32-32V384H96c-17.67 0-32-14.33-32-32V96c0-17.67 14.33-32 32-32h832z\" p-id=\"8491\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/myApp-shelf.svg
// module id = 6vFU
// module chunks = 0